<template>
    <v-app spellcheck="false">
        <router-view></router-view>
        <AppServiceView></AppServiceView>
        <LoadingComponent v-if="isShowLoading"/>
    </v-app>
</template>
<script>
import { mapState } from 'vuex'
import AppServiceView from '@/components/AppServiceView'
import LoadingComponent from '@/modules/fptai/components/LoadingComponent'
import '@/assets/css/common.scss'

export default {
    name: 'App',
    components: {
        AppServiceView,
        LoadingComponent
    },
    computed: {
        ...mapState({
            isShowLoading: state => state.isShowLoading
        })
    }
}
</script>
<style lang="scss">
html {
    overflow-y: auto !important;
}

a {
    text-decoration: none !important;
}

.clearfix:before,
.clearfix:after {
    content: "";
    display: table;
}

.clearfix:after {
    clear: both;
}

/*fix v-select when too small*/
.v-list__tile__content {
    min-width: 17px;
    border-bottom: none;
}

.v-list {
    padding: 6px !important;
    border-radius: 5px !important;
}

.v-list__tile {
    height: 36px !important;
    font-size: 14px !important;
    font-family: "open sans", serif;
    border-radius: 4px !important;
    overflow: hidden;
    padding: 0 10px !important;
}

.v-list__tile__title {
    font-size: 14px !important;
    font-family: "open sans", serif;
}

.v-list__tile--link:hover {
    background: #EEF6FF !important;
    color: #0052CC !important;
    transition: 0.3s;
}

.v-list__tile--active {
    background: #e4edfa !important;
}

.v-menu__content {
    background: #fff;
    max-height: 500px !important;
    border-radius: 5px !important;
    border: 1px solid #e4edfa;

    &::-webkit-scrollbar {
        width: 7px;
        height: 10px;
        background-color: transparent;
        border: none;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.1);
        border: none;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 0, 0, 0.5);
    }
}

div {
    &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
        background-color: transparent;
        border: none;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.1);
        border: none;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 0, 0, 0.5);
    }
}

// custom input longtext
.v-select, v-combobox, v-autocomplete, v-text-field, input {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
